<template>
  <v-container>
    <!-- <div style="margin-top: 20px; margin-bottom: 20px; margin-left: auto; margin-right: auto; height: 200px; width: 80%; overflow-y: auto; overflow-x: auto; border-style: solid; border-width: 1px; padding-top: 10px; padding-left: 10px; padding-bottom: 10px; padding-right: 10px"> -->
    <!-- <v-card elevation="6" height="200px" style="margin-left: 20px; margin-right: 20px; margin-top: 20px; margin-bottom: 20px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; padding-right: 10px; overflow-y: auto"> -->
    
      
    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <h2 class="ml-4 mr-4 mb-0 font-weight-bold">{{cuestionario.Titulo}}</h2>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <img v-bind:src="'https://d2jnzwd77blap.cloudfront.net/wp-content/uploads/2025/01/13084710/logo-40.png'" />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <p class="ml-8 mr-8">Hola, <span style="font-weight: bold">{{ this.$store.state.per.PerNom }}</span></p>
      </v-col>
    </v-row>
   
    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <v-row dense>
          <p class="ml-8 mr-8" v-html="cuestionario.Descripcion" style="text-align: center"></p>
        </v-row>
      </v-col>
      
    </v-row>

    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <p class="ml-8 mr-8">¿Vas a asistir a la fiesta con acompañante?</p></v-col>
    </v-row>

    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <v-radio-group class="ml-8 mr-8 mt-n4" row dense v-model="respuestas.asistencia.respuestaUsuario">
          <v-radio
            label="Si"
            value="true"
          >
          </v-radio>
          <v-radio
            label="No"
            value="false"
          >
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <p class="ml-8 mr-8">¿Vas a asistir con hijos?</p>
      </v-col>
    </v-row>
    
    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <v-radio-group class="ml-8 mr-8 mt-n4" row dense v-model="respuestas.hijos.respuestaUsuario">
          <v-radio
            label="Si"
            value="true"
          >
          </v-radio>
          <v-radio
            label="No"
            value="false"
          >
          </v-radio>
        </v-radio-group>
      </v-col>
      
    </v-row>
    <v-row dense>
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
          <v-select 
              dense outlined hide-details
              :items="IntoleranciasOptions"
              item-value="value"
              item-text="label"
              label="Hijos"
              v-model="respuestas.hijosNumero.respuestaUsuario"
              :menu-props="{ offsetY: true }">
          </v-select>
      </v-col>
    </v-row>

    <!-- </div> -->
    <br>
    <v-row dense >
      <v-col cols="auto" style="margin-left: auto; margin-right: auto">
        <v-btn
          color="primary"
          :loading="loading"
          @click="onClickSaveData"
        >
          Grabar asistencia
        </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import axios from "axios"
  import { mapState } from "vuex";
  // import router from '../router'
  export default {
    computed:{
        ...mapState(['empId', 'perId', 'perAux', 'esEmpleado', 'urlRaiz'])
    },
    data: () => ({
      loading: false,
      cuestionario: {
      Respuestas: []
    },
    
    IntoleranciasOptions: [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' }
      ],

    
    horas:[],

    respuestas:{
      asistencia: { PreguntasCuestionarioId: 64, respuestaUsuario: null },
      hijos: { PreguntasCuestionarioId: 65, respuestaUsuario: null },
      hijosNumero: { PreguntasCuestionarioId: 66, respuestaUsuario: '0' },
    }
    

     
      // mostrarAlergenos: false
    }),

    methods: {
      // validate () {
      //   this.$refs.form.validate()
      //   if (this.valid)
      //   {
      //       this.enviar();
      //   }
      // },
      getDataFromApi() {
        this.loading = true;

        return new Promise((resolve) => {
          const controllerParameters = {
            Titulo: 'MARTIN MARTIN FEST',
            PerId: this.$store.state.per.PerId
          };

          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/cuestionario/get", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data.Cuestionario;
            console.log(result.data.Respuesta);
            setTimeout(() => {
                this.loading = false;
                resolve({
                  item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al cargar el cuestionario');
            }
          });
        })
      },
      postDataToApi() {
        this.loading = true;

        return new Promise((resolve) => {
          const controllerParameters = {
            Respuestas: [ this.respuestas.asistencia, this.respuestas.hijos, this.respuestas.hijosNumero ],
            CuestionarioId: this.cuestionario.CuestionarioId,
            PerId: this.perId,
            DirId: 0
              //DirId: this.perAux != null && this.perAux.Dir != null && this.perAux.Dir.length > 0 ?
              //this.perAux.Dir[0].DirId : null
          };

          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/cuestionario/respuesta/save", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data.Success;

            setTimeout(() => {
                this.loading = false;
                resolve({
                  item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al guardar el cuestionario');
            }
          });
        })
      },
      loadData(){
        this.getDataFromApi()
          .then(data => {
            this.cuestionario = data.item;
          });
      },
      onClickSaveData() {
        if (!this.esEmpleado) {
          alert('DISPONIBILIDAD NO GUARDADA CORRECTAMENTE - Estas intentando guardar la disponibilidad desde el usuario de la tienda, inicia sesión desde tu intranet PERSONAL para grabar la inscripción');
          this.$router.push('/');
          return;
        }

        this.postDataToApi()
          .then(data => {
            const success = data.item;
            if (success)
            {
              alert('Muchas gracias por tu inscripcion, se ha guardado correctamente');
              this.$router.push('/');
            }
          });
      },

    },
    mounted() {
      this.loadData();
    }
  }
</script>